
import {Component, Prop, Vue} from 'vue-property-decorator';
import QrcodeVue from 'qrcode.vue';
import { qiangjianUrl } from "@/constants";
@Component({
  name: 'HelpTable',
  components: {
    QrcodeVue
  }
})
export default class HelpTable extends Vue {
  @Prop({type: Boolean, default: false})
  visible!: boolean;

  @Prop({type: String, default: ''})
  mode!: string;

  helpData: Record<string, {name: string; url: string}[]> = {
    "REGISTER": [
      {name: '账号注册.mp4', url: qiangjianUrl + '/public/video/账号注册.mp4'}
    ]
  };

  qrDialog = {
    visible: false,
    url: '',
    name: ''
  };

  get dialogVisible(): boolean {
    return this.visible;
  }

  get currentList(): {name: string; url: string}[] {
    return this.helpData[this.mode] || [];
  }

  onClose() {
    this.$emit('close');
  }

  onOpen(row: any) {
    window.open(row.url, '_blank');
  }

  onScan(row: any) {
    this.qrDialog = {
      visible: true,
      url: row.url,
      name: row.name
    };
  }

  closeQr() {
    this.qrDialog.visible = false;
  }
}
